import React, { Component } from 'react'

import { connect } from 'react-redux'

import '../style/sms.scss'

//import PackagesCard from './PackagesCard'
import Alert from './Alert'
//import Tabs from './Tabs'
import Checkbox from './Checkbox'
//import DIDAddOns from './DIDAddOns'
import SpecialOfferContactUs from './SpecialOfferContactUs'
import Collapse from './Collapse'
import CheckboxLine from './CheckboxLine'
import InputCounter from './InputCounter'
import Table from './Table'

import { formatStringAsNumber } from '../utils/main'

import { /*setIsSmsMarketing,*/ updateBulkSmsPackage, 
    addReduceBulkSmsPackage, selectSMSTab,
    toggleDIDAddOn, clearBulkSmsPackages
} from '../store/actions/DIDsActions'

import { CAMPAIGN_MESSAGES_LIMIT/*, CAMPAIGN_PRICE_LIMIT*/ } from '../store/reducers/statics/consts';

class SMS extends Component {

    /*setIsMarketing(newValue) {
        this.props.setIsSmsMarketing(newValue);
    }*/

    updateBulkSmsPackage(packageId, newAmount) {
        this.props.updateBulkSmsPackage(packageId, newAmount);
    }
    addReduceBulkSmsPackage(packageId, isAdding) {
        this.props.addReduceBulkSmsPackage(packageId, isAdding);
    }

    selectTab(i) {
        this.props.selectSMSTab(i);
    }

    toggleUnlimited(e, DID) {
        if(this.isBulkSMS()) {
            e.target.checked = false;
        } else {
            this.props.toggleDIDAddOn(DID , "isUnlimited");
        }
    }

    isBulkSMS() {
        const { bulkPackagesSelected } = this.props.DIDsReducer;
        return (
            bulkPackagesSelected && 
            (
                bulkPackagesSelected.S > 0 ||
                bulkPackagesSelected.M > 0 ||
                bulkPackagesSelected.L > 0 ||
                bulkPackagesSelected.XL > 0
            )
        );
    }

    isAnyPackageSelected() {
        const isBulkSMS = this.isBulkSMS();
        if(isBulkSMS) return true;
        const { DIDsAdded: selectedDIDs } = this.props.DIDsReducer;
        return !!selectedDIDs.find(item => item.isUnlimited);
    }

    clearBulkSmsPackages() {
        this.props.clearBulkSmsPackages();
    }

    render() {
        const { /*isMarketing,*/ PlansReducer, DIDsReducer } = this.props;
        const { selectedSMSTab, bulkPackagesSelected, DIDsAdded: selectedDIDs } = DIDsReducer;
        const { unlimitedPackage, bulkPackages } = PlansReducer;
        const isBulkSMS = this.isBulkSMS();

        var bulkSummary = {
            messages: 0,
            price: 0,
        };
        Object.keys(bulkPackagesSelected).forEach(key => {
            const count = bulkPackagesSelected[key];
            const item = bulkPackages.find(el => el.id == key);
            
            bulkSummary = {
                messages: bulkSummary.messages + (Number(item.amount.replace(/,/g, '')) * count),
                price: bulkSummary.price + (Number(item.price.replace(/,/g, '')) * count),
            }
        })

        /*const marketingUI = (
            <div id="marketing">
                <div className="title">
                    Do You Need SMS For Marketing?
                </div>
                <div className="sub-title">
                    Send Thousands of Messages To Your Opted In Users With a Click of a Button!
                </div>
                <div className="btns-holder">
                    <div className="btn" onClick={() => this.setIsMarketing(true)}>Yes</div>
                    <div className="btn" onClick={() => this.setIsMarketing(false)}>No</div>
                </div>
            </div>
        );*/

        const bulkPackagesUI = (
            <div id="packages-holder">
                {
                    (bulkSummary.messages >= CAMPAIGN_MESSAGES_LIMIT/* || 
                    bulkSummary.price >= CAMPAIGN_PRICE_LIMIT*/) && <SpecialOfferContactUs />
                }
                <Table items=
                    {
                        [["SMS Count", "Price Per Month", "Selected Count"],
                            ...(bulkPackages.map((item, i) => {
                                return (
                                    [
                                    (<div><b>{item.amount}</b> msge/month</div>),
                                    ("$" + item.price),
                                    <InputCounter
                                        withoutHolder={false}
                                        onAdd={() => this.addReduceBulkSmsPackage(item.id, true)}
                                        onReduce={() => this.addReduceBulkSmsPackage(item.id, false)}
                                        onChange={(e) => this.updateBulkSmsPackage(item.id, e.target.value)}
                                        value={bulkPackagesSelected[item.id]}
                                        placeholder="Quantity"
                                    />
                                    ]
                                )
                                //return <PackagesCard key={i} id={item.id} name={item.name} price={item.price} amount={item.amount} />
                            }))
                        ]
                    }
                />
                <div className="sub-title" style={{textAlign: "center", fontSize: "1.15rem", fontStyle: "italic", margin: "1.5vh 1.5vw"}}>
                    * Conversational SMS & Campaign SMS for all eligible phone numbers are included with the selected metered plan above
                </div>
            </div>
        );
        /*const packagesUI = (
            <div>
                <div className="packages-holder">
                    {
                        (isMarketing === true ? bulkPackages : [unlimitedPackage]).map((item, i) => {
                            return <PackagesCard key={i} name={item.name} price={item.price} amount={item.amount} />
                        })
                    }
                </div>
                {/*<Alert 
                    type="WARNING"
                    title="Recommadations:" 
                    items={[
                        "Do NOT send more than 500 messages per number per day",
                        isMarketing && "Get at least one number for every 10K messages you buy"
                    ]} />*\/}
            </div>
        );*/
        //const DIDsTableUI = (<div></div>);

        const selectedSMSTable = (
            <div id="selected-numbers">
                <table>
                    <tbody>
                        <tr>
                            <th>Phone Numbers</th>
                            {/*<th>411</th>
                            <th>E911</th>
                            <th>CName</th>*/}
                            <th>SMS Eligible</th>
                            {/*<th>Unlimited 1 to 1 SMS</th>*/}
                            <th>{isBulkSMS ? "Conversational 1 to 1 SMS" : "Unlimited 1 to 1 SMS"}</th>
                        </tr>
                    </tbody>
                        {
                            selectedDIDs.map((item, i) => {
                                const isDisabled = isBulkSMS;
                                const isActive = isBulkSMS ? true : !!item.isUnlimited;
                                return (
                                    <tbody key={item.DID}>
                                        <tr>
                                            <td>{item.DID}</td>
                                            {/*<td>
                                                <Checkbox />
                                            </td>
                                            <td>
                                                <Checkbox />
                                            </td>
                                            <td>
                                                <Checkbox />
                                            </td>*/}
                                            <td>
                                                {
                                                    item.api.smsok ?
                                                    <i className="fas fa-check"></i>
                                                    :
                                                    <i className="fas fa-times"></i>
                                                }
                                            </td>
                                            {/*<td>
                                                <Checkbox />
                                            </td>*/}
                                            <td>
                                                <div style={{display: "flex", flexDirection: "row", 
                                                    justifyContent: "center", alignItems: "center"}}>
                                                    <div style={{display: "flex", flexDirection: "row",
                                                    alignItems: "center", justifyContent: "flex-end", width: "175px"}}>
                                                        <span>{!item.api.smsok ? "Not Eligible" : (isBulkSMS ? "Included" : "$4.99/month")}</span>
                                                        <Checkbox 
                                                            isDisabled={item.api.smsok ? isDisabled : true}
                                                            active={item.api.smsok ? isActive : false} 
                                                            color="blue" style={{marginLeft: ".5rem"}}
                                                            onChange={(e) => {this.toggleUnlimited(e, item.DID)}} />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                )
                            })
                        }
                </table>
            </div>
        );

        const selectedPackage = (
            <div>
                <div style={{textAlign: "center", /*padding: "1.5vh 2.5vw"*/}}>
                    {/*<div className="title">SMS Package Selected:</div>*/}
                    {
                        this.isAnyPackageSelected() ?
                        (
                            isBulkSMS ? (
                                <Alert type="SUCCESS"
                                leftButton={
                                    <div>
                                        <i style={{cursor: "pointer", fontSize: "1.5rem"}} className="fas fa-times-circle" onClick={() => this.clearBulkSmsPackages()}></i>
                                    </div>
                                }>
                                    <div className="title">SMS Package Selected (Account-Wide)</div>
                                    <div className="sub-title">{formatStringAsNumber(bulkSummary.messages)} messages / month</div>
                                    <div className="sub-title">${formatStringAsNumber(bulkSummary.price)} / month</div>
                                </Alert>
                                /*<div className="card">
                                    <div className="title" style={{fontSize: "1.5rem"}}>
                                        {"Campaign & 1 to 1 SMS"}
                                    </div>
                                    <div className="sub-title">{formatStringAsNumber(bulkSummary.messages)} messages / month</div>
                                    <div className="sub-title">${formatStringAsNumber(bulkSummary.price)} / month</div>
                                </div>*/
                            )
                            :
                            (
                                <Alert>
                                    <div className="title" style={{fontSize: "1.5rem"}}>Unlimited 1 to 1 SMS</div>
                                    <div className="sub-title">$4.99 per number per month</div>
                                </Alert>
                                /*<div className="card">
                                    <div className="title" style={{fontSize: "1.5rem"}}>Unlimited 1 to 1 SMS</div>
                                    <div className="sub-title">Unlimted 1 to 1 SMS is $4.99 per number per month</div>
                                </div>*/
                            )
                        )
                        :
                        (
                            <Alert type="WARNING">
                                <div className="title" style={{fontSize: "1.5rem"}}>No Package was selected</div>
                                <div className="sub-title">
                                    In the table above, select an Unlimited 1 to 1 Conversational SMS to the number/s you wish, or choose a metered package which will apply to all eligible numbers on your account and enable A2P functions.
                                </div>
                            </Alert>
                            /*<div className="card warning">
                                <div className="title" style={{fontSize: "1.5rem"}}>No Package was selected</div>
                                <div className="sub-title">In the table below add an Unlimted 1 to 1 SMS to numbers you wish, or click the "Campaign & 1 to 1 Messages" tab above and choose a package which will be applied to all eligible numbers on your account.</div>
                            </div>*/
                        )
                    }
                </div>
            </div>
        );

        const noDIDsSelected = (
            <Alert type="WARNING" title="No phone number was selected">
                <div className="sub-title">
                    You can go to above 'Phone Number' tab to add numbers.
                </div>
            </Alert>
        );

        return (
            //isMarketing === undefined ? marketingUI : packagesUI
            <div>
                <Collapse defaultActiveKey={["0","1"]} activeKey={selectedSMSTab} items={[
                    {
                        headerTitle: <div 
                            style={{display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between", alignItems: "center"}}>
                            <div><b>Conversational</b> SMS $4.99/number each</div> <b>Click to Select</b></div>, 
                        content: (
                            selectedDIDs && selectedDIDs.length <= 0 ? noDIDsSelected :
                        selectedSMSTable),
                    },
                    {
                        headerTitle: <div><b>Conversational & Campaign</b> SMS - Metered (1 credit = 1 message)</div>, 
                        content: bulkPackagesUI,
                    }
                ]} />
                {/*<Tabs
                    tabLinks={[
                        <div>Conversational SMS<br/><div style={{fontWeight: "500", fontSize: "1.15rem"}}>$4.99 per number</div></div>, 
                        <div>Campaign SMS - Metered<br/><div style={{fontWeight: "500", fontSize: "1.15rem"}}>(1 credit = 1 message)</div></div>, 
                    ]} 
                    tabLinkOnClick={(i) => this.selectTab(i)}
                    overrideSelectedTab={selectedSMSTab}
                    tabContainers={[
                        <div></div>,
                        bulkPackagesUI,
                    ]} 
                />
                {selectedSMSTable}
                */}
                {selectedPackage}
                <div className="sub-title" style={{fontSize: "1.15rem", fontStyle: "italic", margin: "1.5vh 1.5vw"}}>
                    * Sending over 10,000 sms/month A2P require explanation of your campaign for proper verification of usage
                    <br/>
                    * A2P (Application to Person) functions are limited to 500 messages per day per number. It is your responsibility to have enough phone numbers to maximize usage according to your metered plan. Unused credits are not rolled over and are not refundable.
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        //isMarketing: state.DIDsReducer.isSmsMarketing,
        /*selectedDIDs: state.DIDsReducer.DIDsAdded,
        selectedSMSTab: state.DIDsReducer.selectedSMSTab,
        bulkPackagesSelected: state.DIDsReducer.bulkPackagesSelected,*/
        DIDsReducer: state.DIDsReducer,
        PlansReducer: state.PlansReducer,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        //setIsSmsMarketing: (newValue) => dispatch(setIsSmsMarketing(newValue)),
        updateBulkSmsPackage: (packageId, newAmount) => dispatch(updateBulkSmsPackage(packageId, newAmount)),
        addReduceBulkSmsPackage: (packageId, isAdding) => dispatch(addReduceBulkSmsPackage(packageId, isAdding)),
        selectSMSTab: (i) => dispatch(selectSMSTab(i)),
        toggleDIDAddOn: (DID, addOnName) => dispatch(toggleDIDAddOn(DID, addOnName)),
        clearBulkSmsPackages: () => dispatch(clearBulkSmsPackages()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SMS);